export const OFFER_TYPES = {
  SUBSCRIPTION: 'subscription',
  PRICE_OFFER_BUNDLE: 'price offer bundle',
  PERSONAL_OFFER: 'personal offer',
  BUNDLE: 'BUNDLE'
}

export function formInput() {
  return [
    [
      {
        name: 'promoCode',
        isToHideLabel: true,
        dataTestId: 'qa-pay-promocode',
        maxLength: '64',
        customClassName: 'promo-code-field col-8',
        ariaLabel: 'promoCode',
        placeholderKey: 'promoCode',
        onInput: e => {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
        },
      },
      {
        name: 'applyButton',
        type: 'inlineSubmitButton',
        dataTestId: 'qa-pay-promocode-apply',
        customClassName: 'promo-code-field col-4',
      },
    ],
  ]
}
